import React from 'react';

import strings from '../../../assets/localization';
import Modal from '../../UI/Modal/Modal';
import NavbarElement from '../../Navigation/Navbar/NavbarElement/NavbarElement';
import HandlingUserDataContent from '../../../assets/localization/hud/HandlingUserData';

const HandlingUserData = (props) => {
  return (
    <Modal
      modalScrollChildrenStyle={{ padding: props.isLandscape ? '1.5rem' : '1rem' }}
      navbarLeftElement={<NavbarElement imgIcon='/sprites.svg#icon-close-small' alt='Close' clicked={props.goBack} />}
      navbarCenterElement={strings.dataManagement}
    >
      <HandlingUserDataContent indexPage />
    </Modal>
  );
};
export default HandlingUserData;
